import * as React from 'react';
// import { rules } from '@nordatec/server/config/rbac.rules';
import { useAuthStore } from '@app/modules/Auth/hooks';

const checkRoles = (permission: string, permissionToAllow: string): boolean => {
  if (permission === permissionToAllow) {
    return true;
  }

  let userMethod = '*';
  let userPath = permission;
  if (/:/.test(permission)) {
    [userMethod, userPath] = permission.split(':');
  }

  let method = '*';
  let path = permissionToAllow;
  if (/:/.test(permissionToAllow)) {
    [method, path] = permissionToAllow.split(':');
  }

  return method === '*' || userMethod === '*' ? userPath === path : false;
};

const check = (permissions, action, params) => {
  // console.log(`Checking permission for : ${action}`);
  if (!permissions) {
    // role is not present in the rules
    return false;
  }

  //.static;
  const staticPermissions = permissions;
  // console.log({staticPermissions});
  if (staticPermissions && staticPermissions.some(permission => checkRoles(permission, action))) {
    // static rule not provided for action
    return true;
  }

  // @todo
  const dynamicPermissions = permissions.dynamic;

  if (dynamicPermissions && dynamicPermissions[action]) {
    const permissionCondition = dynamicPermissions[action];
    return permissionCondition(params);
  }
  return false;
};

interface CanPropsInterface {
  action: string;
  params?: any;
  yes?: Function;
  no?: Function;
}

export const Can: React.FC<CanPropsInterface> = ({ action, params = {}, yes = () => {}, no = () => {} }) => {
  const { userInfo } = useAuthStore();
  // @ts-ignore
  const permissions = userInfo.permissions;
  return check(permissions, action, params) ? yes() : no();
};

Can.defaultProps = {
  yes: () => null,
  no: () => null
};
